module.exports = __webpack_public_path__ + "static/media/Sort Z-a-Selected.e07149b9.svg";